import { connect } from 'react-redux';
import { compose } from 'redux';

import injectSaga from 'utils/injectSaga';
import injectReducer from 'utils/injectReducer';

import PrimoProfile from 'containers/PrimoProfile/Profile';
import { PRIMO_ACCCOUNT_PAGE_KEY } from 'containers/PrimoAccount/constants';
import primoAccountSaga from 'containers/PrimoAccount/saga';
import primoProfileReducer from 'containers/PrimoProfile/reducer';
import primoAccountReducer from 'containers/PrimoAccount/reducer';
import primoProfileSaga from './saga';
import { loadCreditCards, loadBankAccounts } from './actions';
import { PROFILE_PAGE_KEY } from './constants';

const mapDispatchToProps = {
  loadCreditCards,
  loadBankAccounts,
};

const withConnect = connect(null, mapDispatchToProps);

const withReducer = injectReducer({
  key: PROFILE_PAGE_KEY,
  reducer: primoProfileReducer,
});
const withSaga = injectSaga({
  key: PROFILE_PAGE_KEY,
  saga: primoProfileSaga,
});
const withPrimoAccountReducer = injectReducer({
  key: PRIMO_ACCCOUNT_PAGE_KEY,
  reducer: primoAccountReducer,
});
const withPrimoAccountSaga = injectSaga({
  key: PRIMO_ACCCOUNT_PAGE_KEY,
  saga: primoAccountSaga,
});

export default compose(
  withReducer,
  withPrimoAccountReducer,
  withSaga,
  withPrimoAccountSaga,
  withConnect,
)(PrimoProfile);
